resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function Checkbox() {
    this.extends = [_Input];
    this.node = null;
    this.id = null;
    this.declaredClass = null;
    this.containerDiv = null;
    this.inputContainerDiv = null;
    this.checkboxDiv = null;
    this.labelDiv = null;
    this.group = null;

    this.placeholder = "";
    this.disabled = false;
    this.checked = false;

    this.init = function() {
        if (this.node.tagName.toLowerCase() == "input") {
            if ($(this.node).attr("type").toLowerCase() != "checkbox") $(this.node).attr("type", "checkbox");
            this.containerDiv = $("<div class='mogo-ui-checkbox'></div>").insertBefore(this.node)[0];
            this.inputContainerDiv = $("<div class='input-container'></div>")[0];
            $(this.inputContainerDiv).appendTo(this.containerDiv);
            $(this.node).appendTo(this.inputContainerDiv);
            this.checkboxDiv = $("<div class='checkbox-button'></div>").prependTo(this.inputContainerDiv)[0];
            $("<div class='checked'></div>").appendTo(this.checkboxDiv);
            this.labelDiv = $("<label for='" + this.id + "'>&nbsp;</div>").appendTo(this.containerDiv)[0];
            if ($(this.node).attr("placeholder")) this.placeholder = $(this.node).attr("placeholder");
        } else if (this.node.tagName.toLowerCase() == "div") {
            $(this.node).addClass("mogo-ui-checkbox");
            if ($(this.node).html() != "")
                this.placeholder = $(this.node).html();
            else if ($(this.node).attr("placeholder"))
                this.placeholder = $(this.node).attr("placeholder");
            $(this.node).html("");
            this.containerDiv = this.node;
            this.inputContainerDiv = $("<div class='input-container'></div>")[0];
            $(this.inputContainerDiv).appendTo(this.containerDiv);
            this.node = $("<input type='checkbox' />")[0];
            $(this.node).appendTo(this.inputContainerDiv);
            this.checkboxDiv = $("<div class='checkbox-button'></div>").prependTo(this.inputContainerDiv)[0];
            $("<div class='checked'></div>").appendTo(this.checkboxDiv);
            this.labelDiv = $("<label for='" + this.id + "'>&nbsp;</div>").appendTo(this.containerDiv)[0];
            var attributes = this.containerDiv.attributes;
            for (var i = attributes.length - 1; i >= 0; i--) {
                var attribute = attributes[i];
                if (attribute.name != "class" && attribute.name != "style") {
                    $(this.node).attr(attribute.name, attribute.value);
                    $(this.containerDiv).removeAttr(attribute.name);
                }
            }
        }

        if ($(this.node).attr("name"))
            this.group = $(this.node).attr("name");
        else
            this.group = $(this.node).attr("name", this.id);

        if (this.placeholder != "") {
            $(this.labelDiv).html(this.placeholder);
        }

        if (this.node.checked) {
            this.checked = true;
            $(this.containerDiv).addClass("selected");
        }

        if (this.node.disabled) {
            $(this.containerDiv).addClass("disabled");
        }

        // Connections
        $(this.node).on("change", $.proxy(this._onNodeChange, this));
        $(this.node).on("focus", $.proxy(this._onFocus, this));
        $(this.node).on("blur", $.proxy(this._onBlur, this));
        $(this.checkboxDiv).on("click", $.proxy(this._onCheckboxClick, this));

        $(this.node).css("display", "block");
    };

    this.initAllReady = function() {};

    this.setChecked = function(value) {
        if (typeof value == "boolean") {
            this.checked = value;
            this.node.checked = value;
            if (this.checked) {
                $(this.containerDiv).addClass("selected");
            } else {
                $(this.containerDiv).removeClass("selected");
            }
        }
    };

    this.val = function(value) {
        if (value == null) {
            if ($(this.node)[0].checked)
                return $(this.node).val();
            else
                return null;
        } else {
            this.setChecked(value);
        }
    };

    this._onNodeChange = function(evt) {
        this.setChecked(this.node.checked);
    };

    this._onCheckboxClick = function(evt) {
        $(this.node).click();
    };

    this._onFocus = function(evt) {
        $(this.containerDiv).addClass("focused");
    };

    this._onBlur = function(evt) {
        $(this.containerDiv).removeClass("focused");
    };
}